export interface QUESTIONS_LANGUAGE_MAP {
  deutsch: string;
  englisch: string;
  französisch: string;
  italienisch: string;
}

export interface JOB_OFFER_STANDARD_QUESTIONS_MAP {
  [key: string]: QUESTIONS_LANGUAGE_MAP;
}
export class JobOfferStandardQuestions {
  public static listQuestionsDeutsch = [
    "Bitte geben Sie Ihren Vornamen in das Textfeld ein und klicken Sie auf weiter.",
    "Bitte geben Sie Ihren Nachnamen ein und klicken Sie auf weiter.",
    "Bitte geben Sie Ihren Geburtsnamen ein und drücken Sie auf weiter.",
    "Bitte geben Sie Ihre Straße in das Textfeld ein und klicken Sie auf weiter.",
    "Geben Sie auch Ihre Hausnummer in das Textfeld ein und klicken Sie auf weiter.",
    "Ihre Postleitzahl tippen Sie ebenfalls in das Textfeld und klicken Sie auf weiter.",
    "Geben Sie bitte Ihren Wohnort in das Textfeld ein und klicken Sie auf weiter.",
    "Geben Sie bitte Ihr Land ein, in dem Sie leben und klicken Sie auf weiter.",
    "Tippen Sie Ihre Nationalität ein und klicken Sie auf weiter.",
    "Bitte geben Sie ihr Geburtsland ein und drücken Sie auf weiter.",
    "Bitte geben Sie Ihre EMail Adresse in das Textfeld ein.",
    "Bitte geben Sie Ihre Telefonnummer ein.",
    "Tragen Sie Ihre Handynummer in das untenstehende Textfeld ein.",
    "Vielen Dank für deine Bewerbung! Ich wünsche dir noch einen schönen Tag!",
    "Bitte wählen Sie eine der folgenden Sprachen.",
    "Hallo, schön dich kennenzulernen. Bitte lade zuerst deinen Lebenslauf hoch.",
    "Sie sind nun mit dem Bewerbungsprozess fertig. Sie können diesen Tab jetzt schließen.",
    "Wann ist ihr Geburtstag?"
  ];

  // public static listQuestionsEnglish = [
  //   "Please enter your First Name in the text field and click continue.",
  //   "Please enter your Last Name and click continue.",
  //   "Please enter your Birth Name and press continue.",
  //   "Please enter your Street in the text field and click continue.",
  //   "Please also enter your House Number in the text field and click continue.",
  //   "Please also enter your Postal Code in the text field and click continue.",
  //   "Please enter your place of residence in the text field and click continue.",
  //   "Please enter the country in which you live and click continue.",
  //   "Type in your Nationality and click continue.",
  //   "Please enter your Country of Birth and press continue.",
  //   "Please enter your Email Address in the text field.",
  //   "Please enter your Telephone Number.",
  //   "Enter your Mobile Number in the text field below.",
  //   "Thank you for your Application! Have a nice day!",
  //   "Please select one of the following Languages.",
  //   "Hello, nice to meet you. Please upload your CV first.",
  //   "You are now finished with the application process. You can now close this tab.",
  //   "When is your Birthday?"
  // ];

  // public static listQuestionsFranzösisch = [
  //   "Veuillez entrer votre prénom dans le champ de texte et cliquez sur Suivant.",
  //   "Veuillez entrer votre nom de famille et cliquez sur Continuer.",
  //   "Veuillez entrer votre nom de naissance et appuyez sur Continuer.",
  //   "Veuillez entrer votre Adresse postale dans le champ de texte et cliquez sur Continuer.",
  //   "Entrez votre Numéro de Maison dans le champ de texte et cliquez sur Suivant.",
  //   "Tapez votre code Postal dans le champ de texte et cliquez sur suivant.",
  //   "Veuillez saisir votre lieu de résidence dans le champ de texte et cliquez sur continuer.",
  //   "Veuillez saisir le pays dans lequel vous vivez et cliquez sur Continuer.",
  //   "Entrez votre Nationalité et cliquez sur suivant.",
  //   "Veuillez entrer votre pays de naissance et appuyez sur Continuer.",
  //   "Veuillez saisir votre adresse e-mail dans le champ de texte.",
  //   "Veuillez saisir votre Numéro de Téléphone.",
  //   "Entrez votre Numéro de Portable dans le champ de Texte ci-dessous.",
  //   "Merci beaucoup pour votre Candidature ! Je vous souhaite une bonne Journée !",
  //   "Veuillez sélectionner l'une des Langues suivantes.",
  //   "Bonjour, ravi de vous rencontrer. Veuillez d'abord Télécharger votre CV.",
  //   "Vous avez maintenant terminé le processus de candidature. Vous pouvez maintenant fermer cet onglet.",
  //   "Quand est votre Anniversaire ?"
  // ];
  // public static listQuestionsItalienisch = [
  //   "Inserisci il tuo Nome nel campo di testo e clicca su Avanti.",
  //   "Inserisci il tuo Cognome e clicca su Continua.",
  //   "Inserisci il tuo Nome di Nascita e premi Continua.",
  //   "Inserisci il tuo Indirizzo nel campo di testo e clicca su Avanti.",
  //   "Inserisci anche il tuo Numero Civico nel campo di testo e clicca su Avanti.",
  //   "Inserisci anche il tuo Codice Postale nel campo di testo e clicca su Avanti.",
  //   "Inserisci il tuo luogo di residenza nel campo di testo e clicca su Avanti.",
  //   "Inserisci il Paese in cui vivi e clicca su Avanti.",
  //   "Digita la tua Nazionalità e clicca su Avanti.",
  //   "Inserisci il tuo Paese di Nascita e premi Continua.",
  //   "Inserisci il tuo Indirizzo Email nel campo di testo.",
  //   "Inserisci il tuo Numero di Telefono.",
  //   "Inserisci il tuo Numero di Cellulare nel campo di testo sottostante.",
  //   "Grazie per la tua Candidatura! Buona Giornata!",
  //   "Seleziona una delle seguenti Lingue.",
  //   "Ciao, piacere di conoscerti. Per favore carica prima il tuo CV.",
  //   "Ora hai finito con il processo di richiesta. Ora puoi chiudere questa scheda.",
  //   "Quando è il tuo Compleanno?"
  // ];

  public static messagesNotAllowedToBeTyped = [
    'start', 'end session'
  ];
}

export class JobOfferKeywords {
  // public static supportedLanguages = ["deutsch", "englisch", "französisch", "italienisch"];
  public static listKeysDeutsch = [
    "Vorname",
    "Nachname",
    "Geburtsname",
    "Straße",
    "Hausnummer",
    "Postleitzahl",
    "Wohnort",
    "Land",
    "Nationalität",
    "Geburtsland",
    "EMail",
    "Telefonnummer",
    "Handynummer",
    "Danke",
    "Sprache",
    "CV Upload",
    "Ende",
    "Geburtsdatum"
  ];

  public static deutschKeysToBeKeptChecked = [
    "Vorname",
    "Nachname",
    "EMail",
    "Handynummer"
  ];

  public static keywordsNotAllowedToBeTyped = [
    ...JobOfferKeywords.listKeysDeutsch.map(key => key.toLowerCase()),
    'vertrag', 'start', 'end session'
  ];

  public static trueAnswerForIsDocumentUploadTranslated = {
    deutsch: "true",
  }

  public static falseAnswerForIsDocumentUploadTranslated = {
    deutsch: "false",
  }

  public static vertragParameterObj = {
    deutsch: "Vertrag",
  }

  public static extractMainKeywordAIStopWords = new Set([
    "der", "die", "das", "ein", "eine", "einen", "einem", "einer", "den", "dem", "des",
    "ich", "du", "er", "sie", "es", "wir", "ihr", "mein", "dein", "sein", "ihr", "unser",
    "in", "an", "auf", "bei", "mit", "nach", "von", "zu", "über", "unter", "durch", "gegen",
    "und", "oder", "aber", "weil", "dass", "ob", "obwohl", "falls", "während", "sobald",
    "sein", "habe", "werden", "können", "müssen", "sollen", "dürfen", "wollen", "mögen",
    "nicht", "ja", "nein", "doch", "schon", "noch", "immer", "oft", "manchmal",
    "sehr", "mehr", "weniger", "viel", "wenig", "hier", "dort", "überall", "nirgendwo",
    "also", "auch", "ebenso", "nur", "vielleicht", "jedoch", "allerdings", "jemand", "niemand"
  ]);
}